"use client";

import React, {useMemo} from "react";
import {StaticContent} from "@/types/dto/pdp/pdp-contentful";
import {TourHeader} from "@/types/dto/pdp/pdp-header-about";
import {TourDate} from "@/types/dto/pdp/pdp-dates-inclusions-pricing";
import DataLayer from "@/components/data-layer/data-layer";
import {useUserGroups} from "@/hooks/login/useUserGroups";
import dataLayerFactory from "@/factories/pdp/pdp-data-layer-factory";

interface PdpDataLayerProps {
  staticData: StaticContent;
  tourHeaderData: TourHeader;
  selectedDate: TourDate;
}

const PdpDataLayer = ({
  staticData,
  tourHeaderData,
  selectedDate
}: PdpDataLayerProps) => {
  const {isAgent} = useUserGroups();

  const { pageLoadData, ecommerceData } = useMemo(() =>
    dataLayerFactory(staticData, tourHeaderData, selectedDate, isAgent)
    // should only update on date change to prevent multiple pushes being made due to re-renders (JF)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  , [selectedDate]);

  return (
    <>
      <DataLayer data={pageLoadData} />
      <DataLayer data={ecommerceData} />
    </>
  );
};

export default PdpDataLayer;